import * as React from 'react';
// import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useContext, useState} from "react";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, {SelectChangeEvent} from '@mui/material/Select';
import InsertTemplateAcOne from "./InsertTemplateAcOne";
import IceButton from "../../components/Button";
import AuthContext from "../../context/AuthContext";


export default function DialogSetDefaultFeatMap(props: any) {
    let {authTokens, serverIP} = useContext(AuthContext)
    let {open, setOpen, keyDataSet, setDialogResult, featDefmapStatus, setFeatDefmapStatus} = props

    const handleClose = () => {
        setOpen(false);
    };

    const handleApply = () => {
        fetch(`${serverIP}/featdefaultmapset/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({...keyDataSet, featDefmapStatus: featDefmapStatus}),
        }).then(res => res.json())
            .then((data) => {
                if (data.result === 'set') {
                    setDialogResult('defaultMapSet')
                    setFeatDefmapStatus('isDefault')
                    setOpen(false);
                } else if (data.result === 'removed') {
                    setDialogResult('defaultMapRemoved')
                    setFeatDefmapStatus('None')
                    setOpen(false);
                }
            })
    };

    return (

        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Set default mapping</DialogTitle>
            <DialogContent>
                <DialogContentText style={{fontSize: '0.9rem'}}>
                    {featDefmapStatus === 'canBeDefault' ?
                        <>
                            You are about to set this feature as "default". <br/>
                            As a result, this mapping will be automaticalily applied to all features with the same
                            FeatureID in all categories.<br/>
                            A mapping can be changed or overriden in any feature of any category, but by default this
                            mapping will be applied.
                        </>
                        :
                        <>
                            You are about to remove this feature from the "default". <br/>
                            As a result, this mapping won't be used in other features with the same FeatureID.
                        </>
                    }
                </DialogContentText>

            </DialogContent>
            <DialogActions style={{margin: '0 10px 10px 0'}}>
                {/*<div style={{}}>*/}
                <IceButton type="primary" text="Apply" onclick={handleApply} />
                <IceButton type="delete" text="Cancel" onclick={handleClose} />
                {/*</div>*/}
                {/*MUI BUTTON --> <Button sx={{color: "#21409b !important"}} onClick={handleClose}>Close</Button>*/}
            </DialogActions>
        </Dialog>
    );
}
